import React from 'react';
import { connect } from 'react-redux';

import { toggleModalWithTimer, toggleModal } from 'apps/auth/actions/appAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const OnfidoWaitingStatus = (props) => {
    const { gotIt, waitingTitle, waitingText, subTitle, waitingTextInTimer } = usePageMessages();
    return (
        <ModalComponent canCloseModal={false}>
            <InfoPage
                insideModalComponent
                iconName="clock-80"
                iconColor="primary"
                headerText={waitingTitle}
                secondaryText={
                    <>
                        <p>{waitingText}</p>
                        <p>{subTitle}</p>
                    </>
                }
                primaryButtonCaption={gotIt}
                primaryButtonType="link"
                primaryButtonLink="#"
                primaryButtonOnClick={() =>
                    props.toggleModalWithTimer(true, waitingTextInTimer, () => {
                        props.toggleModalWithTimer(false, '', false).then(() => props.toggleModal(false));
                    })
                }
            />
        </ModalComponent>
    );
};

export default connect(null, { toggleModalWithTimer, toggleModal })(OnfidoWaitingStatus);
